// extracted by mini-css-extract-plugin
export default {"spinner":"Preloader_spinner__0W41O","animate":"Preloader_animate__kLlAJ"};